import { gql } from '@apollo/client';

export const APPLY_RULES = gql`
  mutation applyClientRules($clientId: String!) {
    applyClientRules(clientId: $clientId, input: {})
      @rest(
        type: "ApplyClientRulesBatchResult"
        endpoint: "mainapp"
        method: "PUT"
        path: "document.json/client/{args.clientId}/applyClientRules"
      ) {
      message
    }
  }
`;
